import { motion } from "framer-motion";
import { Instagram, Music2, Facebook, Twitter, Youtube, Ghost } from "lucide-react";

const socials = [
  { name: "Instagram", handle: "@hot.packz.grabba", url: "https://www.instagram.com/hot.packz.grabba/", icon: Instagram, live: true },
  { name: "TikTok", handle: "Coming soon", url: "#", icon: Music2, live: false },
  { name: "Snapchat", handle: "Coming soon", url: "#", icon: Ghost, live: false },
  { name: "Facebook", handle: "Hot Packz Grabba", url: "https://www.facebook.com/profile.php?id=61593601870026", icon: Facebook, live: true },
  { name: "X / Twitter", handle: "Coming soon", url: "#", icon: Twitter, live: false },
  { name: "YouTube", handle: "Coming soon", url: "#", icon: Youtube, live: false },
];

export default function Socials() {
  return (
    <section id="socials" data-testid="socials" className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-12 max-w-2xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-blaze mb-4">Follow The Movement</p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            Stay <span className="text-fire">connected</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-6 gap-px bg-surface-border border border-surface-border">
          {socials.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.a
                key={s.name}
                data-testid={`social-${s.name.toLowerCase().split(" ")[0]}`}
                href={s.url}
                target={s.live ? "_blank" : undefined}
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                className={`group relative bg-ink p-8 flex flex-col gap-6 transition-colors duration-300 ${
                  s.live ? "hover:bg-blaze cursor-pointer" : "cursor-default"
                }`}
                onClick={(e) => !s.live && e.preventDefault()}
              >
                <Icon size={28} className={`${s.live ? "text-blaze group-hover:text-white" : "text-muted-foreground"} transition-colors duration-300`} />
                <div>
                  <h3 className="font-heading uppercase text-lg tracking-tight group-hover:text-white">{s.name}</h3>
                  <p className={`text-sm mt-1 font-mono ${s.live ? "text-gold group-hover:text-white/90" : "text-muted-foreground/60"}`}>
                    {s.handle}
                  </p>
                </div>
                {!s.live && (
                  <span className="absolute top-4 right-4 font-mono text-[9px] uppercase tracking-widest text-muted-foreground/50 border border-surface-border px-2 py-1">
                    Soon
                  </span>
                )}
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
